import Loading from 'Components/Atoms/Loading/Loading';
import { Fill } from 'nano-slots';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SAVED_TIMEOUT = 1000;

export default function DrawerStackSavingIndicator(props) {
    const { saving } = props;
    const { t } = useTranslation('common');
    const [showSaving, setShowSaving] = useState(false);
    const [showSaved, setShowSaved] = useState(false);
    const timeoutRef = useRef(null);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (saving) {
            setShowSaving(true);
            setShowSaved(false);
            clearTimeout(timeoutRef.current);
        } else {
            setShowSaving(false);
            setShowSaved(true);
            timeoutRef.current = setTimeout(() => {
                setShowSaved(false);
            }, SAVED_TIMEOUT);
        }

        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, [saving]);

    if (!showSaving && !showSaved) {
        return null;
    }

    return (
        <Fill name="drawer-stack-header">
            {showSaved && (
                <div className="flex items-center gap-1.5 text-success">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12">
                        <rect width="12" height="12" fill="#fff" rx="6"></rect>
                        <rect width="12" height="12" fill="currentColor" rx="6"></rect>
                        <path
                            stroke="#fff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="0.9"
                            d="M8.7 3.6 5.46 8.4 3.3 6.185"
                        ></path>
                    </svg>
                    <span className="text-xs font-semibold">{t('saved')}</span>
                </div>
            )}

            {showSaving && (
                <div className="flex items-center gap-1.5">
                    <Loading size="extraSmall" />
                    <span className="text-xs font-semibold text-gray-500">{t('saving')}</span>
                </div>
            )}
        </Fill>
    );
}

DrawerStackSavingIndicator.propTypes = {
    saving: PropTypes.bool,
};
